export const isAuthSelector = (state) => state.auth.isAuth;
export const userSelector = (state) => state.auth.user;
